export default {
  set(state, { data }) {
    state.coils = data;
  },
  show(state, { data }) {
    state.coil = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}